<template>
  <div class="center-echarts">
    <div ref="main" class="echarts"></div>
    <div class="middle-content" v-if="echartsData.length > 0">
      <p>{{getNum}}</p>
      <div>企业总数</div>
    </div>
    <div v-else class="no-data">暂无产业分布信息</div>
  </div>
</template>

<script>
import * as echarts from "echarts"
export default {
  props: {
    coTypeNumMap: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getNum () {
      return this.echartsData.reduce((total, item) => total + item.value, 0)
    }
  },
  data() {
    return {
      myChart: null,
      // colors: "#1890FF", "#1EC4C8", "#267ECC", "#A0DEFF", "#FFCC79"],
      colors: ["#0053F8", "#03BEF1", "#E8A464", "#1890FF", "#1EC4C8", "#267ECC", "#A0DEFF", "#FFCC79"],
      echartsData: [],
      legendData: [],
      optionData: []
    }
  },
  mounted() {
    for (let i = 0; i < 2; i++) {
      this.colors = this.colors.concat(this.colors)
    }
  },
  methods: {
    drawChart() {
      const that = this
      this.myChart && this.myChart.dispose()
      if (!this.echartsData || this.echartsData.length === 0) return
      this.myChart = echarts.init(this.$refs.main)
      // let sum = this.echartsData.reduce((total, item) => total + item.value, 0)
      const option = {
        legend: {
          orient: 'vertical',
          type: 'scroll', // 显示分页
          selectedMode: false, // 关闭图例的选择模式  
          right: '15%',
          top: '10%',
          bottom: '10%',
          itemGap: 20,
          pageIconInactiveColor: '#267ECC',
          pageIconSize: 15,
          pageIconColor: '#8CD8FF',
          pageTextStyle: {
            color: '#E9F5FF',
            fontSize: 18
          },
          textStyle: {
            rich: {
              // 左侧图例样式
              default: {
                color: '#E9F5FF',
                fontSize: 15,
                width: 100
              }
            },
            // color: '#FFFFFF',
            color: (params) => that.colors[params.dataIndex] || '#3e44ec',
            fontSize: this.$remToPx(0.14),
            'margin-bottom': this.$remToPx(0.18),
          },
          itemWidth: this.$remToPx(0.08),
          itemHeight: this.$remToPx(0.08),
          formatter: val => {
            let obj = this.echartsData.find(item => item.name === val)
            const ellipsis = val.length > 6 ? "..." : "";
            let name = ''
            if (val.length > 1) {
              name = val.substring(0, 6) + ellipsis;
            }
            let str = `{default|${name}}  {percent|${obj.value}}`;
            return str;
          },
          data: this.echartsData.map((dItem, dIndex) => {
            return {
              ...dItem,
              textStyle: {
                rich: {
                  percent: {
                    color: this.colors[dIndex] || '#3e44ec',
                  },
                }
              },

            }
          }),
          // itemGap: 8
        },
        series: [
          // {
          //   name: "外边框",
          //   type: "pie",
          //   hoverAnimation: false,
          //   center: ['30%', '50%'],
          //   radius: ["50%", "75%"],
          //   minAngle: 10,
          //   label: {
          //     normal: {
          //       show: false,
          //     },
          //   },
          //   itemStyle: {
          //     color: '#37495B',
          //     opacity: 0.5
          //   },
          //   data: [1]
          // },
          {
            name: "",
            type: "pie",
            hoverAnimation: false,
            center: ['50%', '50%'],
            radius: ["60%", "85%"],
            width: '180',
            // minAngle: 10,
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              // color: (params) => this.colors[params.dataIndex / 2] || '#3e44ec',
              color: (params) => this.colors[params.dataIndex] || '#3e44ec',
            },
            data: this.optionData
            // data: this.echartsData
          },
          // {
          //   // 饼图圈
          //   type: 'pie',
          //   zlevel: 3,
          //   // radius: ['25%', '35%'],
          //   // center: ['25%', '50%'],
          //     center: ['22%', '50%'],
          //   radius: ["40%", "65%"],
          //   itemStyle: {
          //     borderRadius: 10,
          //     normal: {
          //       //  borderColor: '#0A1934',
          //       // borderWidth:5,
          //       color: function (params) {
          //         return that.colors[params.dataIndex / 2] || '#3e44ec'
          //       }
          //     }
          //   },
          //   label: {
          //     show: false,
          //   },
          //   data: this.optionData,
          // },
        ]
      }
      this.myChart.setOption(option)
    }
  },
  watch: {
    coTypeNumMap(val) {
      // val = {
      //   '房屋租赁、房屋租赁': 100,
      //   '房屋租赁2': 200,
      //   '房屋租赁3': 3,
      //   '房屋租赁4': 4,
      //   '房屋租赁5': 4,
      //   '房屋租赁6': 4,
      //   '房屋租赁7': 4,
      //   '房屋租赁8': 4,
      //   '房屋租赁9': 4,
      //   '房屋租赁10': 4,
      //   '房屋租赁11': 4,
      //   '房屋租赁12': 4,
      //   '房屋租赁13': 4,
      //   '房屋租赁14': 4,
      // }
      let echartsData = []
      let legendData = []

      // let sum = 0;
      let optionData = []
      // for (const key in val) {
      //   sum += Number(val[key]);
      // }

      for (const key in val) {
        legendData.push(key)
        echartsData.push({
          name: key,
          value: val[key]
        })

        optionData.push({ value: val[key], name: key });
        // 配置一个空值
        // if (val && Object.keys(val).length > 1) {
          // optionData.push({ name: '', value: sum / 100, itemStyle: { color: 'transparent' } });
        // }
      }

      // let sum = 0;
      // let optionData = []
      // val.forEach(item => {
      //   sum += Number(item.value);
      // })
      // data.forEach(item => {
      //   optionData.push({ value: item.value, name: item.name });
      //   // 配置一个空值
      //   optionData.push({ name: '', value: sum / 100, itemStyle: { color: 'transparent' } });
      // })

      this.echartsData = [].concat(echartsData)
      this.legendData = [].concat(legendData)
      this.optionData = [].concat(optionData)
      this.drawChart()
    }
  },
  beforeDestroy () {
    this.myChart && this.myChart.dispose()
    this.myChart = null
  }
}
</script>

<style lang="scss" scoped>
.center-echarts {
  // position: relative;
  // height: 100%;
  // width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .echarts {
    height: 100%;
    width: 100%;
  }
  .middle-content {
    // position: absolute;
    // left: 0.9rem;
    // top: 0.98rem;
    // width:1rem;
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    div {
      font-size: 16px;
      color: #A3CAFD;
    }
    p {
      font-size: 32px;
      color: #E4F4FF;
    }
  }
  .no-data {
    position: absolute;
    left: 0;
    top: 0.8rem;
    right: 0;
    font-size: 26px;
    color: #fff;
    text-align: center;
    margin: auto;
  }
}
</style>